import kr from '../kr/kr';
import HTMLClass from '../kr/utils/HTMLClass';

export default class ResponsiveNavbarSubmenu extends kr.Component {
    init() {

        this._enabled = false;
        this.$submenus = this.$element.querySelectorAll('.menu__ul--depth-1');

        if (window.innerWidth <= 1024) {
            this._enabled = true;
        } else {
            this._enabled = false;
        }

        let bounce = false;
        window.addEventListener('resize', () => {
            if (bounce) {
                return;
            }
            bounce = true;
            setTimeout(() => {
                if (window.innerWidth <= 1024) {
                    this._enabled = true;
                } else {
                    this._enabled = false;
                }
                bounce = false;
            }, 100);
        });

        this.on('click', '.menu__ul--depth-0 .menu-item-has-children > a', (target, event) => {
            if (!this._enabled) {
                return true;
            }
            event.preventDefault();
            const parent = target.parentNode;
            if (!parent.children[1].classList.contains('menu__ul--depth-sub-active')) {       
                parent.children[1].classList.add('menu__ul--depth-sub-active');
            } else {
                parent.children[1].classList.remove('menu__ul--depth-sub-active');
            }
        });
    }
}

kr.registerComponent('.topbar__case', {
    component: ResponsiveNavbarSubmenu
});